import React from 'react';

class Button extends React.Component {
    constructor(props) {
        super(props);
        var isNext = this.props.direction === 1;
        var direction = isNext ? ">" : "<";
        this.state = {
            isNext: isNext,
            direction: direction
        };

        this.nextOrPrevious = this.nextOrPrevious.bind(this);
    }
    render() {
        var directionClass = this.state.isNext ? 'button-right' : 'button-left';
        var label = this.state.isNext ? 'Next day' : 'Previous day';
        return (
            <button
                className={'btn day-nav-button ' + directionClass}
                onClick={this.nextOrPrevious}
                title={label}
                aria-label={label}
            >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                    {this.state.isNext
                        ? <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z" />
                        : <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                    }
                </svg>
            </button>
        )
    }
    nextOrPrevious(ev) {
        this.props.updater(this.state.isNext);
    }
}

export default Button;